import { render } from "./App.vue?vue&type=template&id=29ea3b8e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__